export default __webpack_public_path__ + "static/bunker-phones-2-mobile-49f0d883e9648304322e65e7d0f85b52.jpg";